/* Theme Processing/Onload */
document.addEventListener("DOMContentLoaded", function () {
  /* globals for scroll performance */
  const brandBarHeight = document.querySelector(".global-brand-bar")?.clientHeight || 0;
  const siteHeader = document.querySelector(".site-header");
  const page = document.getElementById("page");
  window.brandBarHeight = brandBarHeight;
  window.siteHeader = siteHeader;
  window.page = page;

  loadActiveTab();
  addMenuClicks();

  const throttledResizeHandler = throttle(() => {
    stickyMenu();
  }, 100);

  const throttledScrollHandler = throttle(stickyMenu, 100);

  window.addEventListener("resize", function () {
    redoHomepageHeader();
    if (window.innerWidth < 992) {
      let left = document.querySelector('.rbt-fixed.left-col');
      if (left) { left.style.removeProperty('top'); }
    }
    stickyMenu();
  });

  window.addEventListener("scroll", throttle(handleScroll, 100));

  let processlist = document.querySelectorAll("[data-process]");
  processlist.forEach((item) => {
    let process = item.getAttribute("data-process");
    switch (process) {
      case "rbtQuery":
        rbtQuery(item);
        break;
      case "getSavedPosts":
        getSavedPosts(item);
        break;
      case "doCarousel":
        doCarousel(item);
        break;
      default:
        break;
    }
  });
});

// Throttle and Debounce Implementation
let scrollTimeout;

function handleScroll(e) {
  stickyMenu(e);

  clearTimeout(scrollTimeout);
  scrollTimeout = setTimeout(() => {
    stickyMenu(e); // Run stickyMenu one last time after scroll completes
  }, 100); // Adjust timeout as needed
}

function throttle(fn, wait) {
  let time = Date.now();
  return function (...args) {
    if ((time + wait - Date.now()) < 0) {
      fn.apply(this, args);
      time = Date.now();
    }
  };
}

const loadActiveTab = () => {
  const hash = window.location.hash;
  if (hash) {
    // Remove the leading '#' from the hash
    ///#/tab/tab-two
    const hashPath = hash.replace("#/", "");
    const hashArray = hashPath.split("/");
    const tabId = hashArray[0] == "tab" ? hashArray[1] : false;
    console.log("tabID", tabId);
    console.log("hashArray", hashArray);
    if (tabId) {
      const tabControl = document.getElementById(`ctrl-${tabId}`);
      const tabPanel = document.getElementById(tabId);
      if (!tabControl || !tabPanel) return;
      let currentActiveControls = document.querySelectorAll(".nav-tab.active");
      let currentActivePanels = document.querySelectorAll(
        ".wp-block-rbt-tabpanel.active",
      );
      for (let i = 0; i < currentActiveControls.length; i++) {
        currentActiveControls[i].classList.remove("active");
        var mobileContent =
          currentActiveControls[i].querySelectorAll(".mobile-content");
        if (mobileContent)
          mobileContent.forEach((item) => {
            item.remove();
          });
      }
      for (let i = 0; i < currentActivePanels.length; i++) {
        currentActivePanels[i].classList.remove("active");
      }
      tabPanel.classList.add("active");
      tabControl.classList.add("active");
      /* Clone Node deep */
      let mc = tabControl.querySelector(".mobile-content");
      if (!mc) {
        mc = document.createElement("div");
        mc.classList.add("mobile-content");
        mc.innerHTML = tabPanel.innerHTML;
        tabControl.appendChild(mc);
      }
    }
  }
};

function redoHomepageHeader() {
  let header = document.querySelector('[data-process="doCarousel"]');
  if (header) { doCarousel(header); }
}


function adjustSubMenuPosition(subMenu) {
  const viewportWidth = window.innerWidth;
  const padding = 30; // Padding from the viewport edge

  // Temporarily show the submenu to get its dimensions
  subMenu.style.visibility = "hidden";
  subMenu.style.display = "grid";
  // Reset any previous adjustments
  subMenu.style.left = "50%";
  subMenu.style.transform = "translateX(-50%)";
  const subMenuRect = subMenu.getBoundingClientRect();
  const parentRect = subMenu.closest(".menu-item").getBoundingClientRect();
  subMenu.style.display = "";
  subMenu.style.visibility = "";

  // Check if the submenu overflows the viewport
  if (subMenuRect.left < padding) {
    subMenu.style.left = `${padding - parentRect.left}px`;
    subMenu.style.transform = "none";
  } else if (subMenuRect.right > viewportWidth - padding) {
    subMenu.style.left = "auto";
    subMenu.style.right = `${padding - (viewportWidth - parentRect.right)}px`;
    subMenu.style.transform = "none";
  }
}
// function stickyMenu(e) {
//   if (window.scrollY >= brandBarHeight) {
//     if (!siteHeader.classList.contains("sticky")) {
//       siteHeader.classList.add("sticky");
//       page.style.marginTop = `${siteHeader.offsetHeight}px`; // Prevent content jump
//     }
//   } else {
//     if (siteHeader.classList.contains("sticky")) {
//       siteHeader.classList.remove("sticky");
//       page.style.marginTop = "0px";
//     }
//   }
// }
function stickyMenu(e) {
  const currentHeaderHeight = siteHeader.offsetHeight;

  if (window.scrollY >= brandBarHeight) {
    if (!siteHeader.classList.contains("sticky")) {
      siteHeader.classList.add("sticky");
      page.style.marginTop = `${currentHeaderHeight}px`; // Prevent content jump
    }
  } else {
    if (siteHeader.classList.contains("sticky")) {
      siteHeader.classList.remove("sticky");
      page.style.marginTop = "0px"; // Reset margin-top when not sticky
    }
  }
  if (window.innerWidth < 992) return;

  // Adjust the .rbt-fixed top position dynamically based on the sticky header's height
  const fixedElement = document.querySelector('.rbt-fixed');
  if (fixedElement) {
    fixedElement.style.top = `${siteHeader.classList.contains("sticky") ? currentHeaderHeight : 0}px`;
  }
}

window.hoverTimeout;

function toggleHover(event) {
  const menuItem = event.currentTarget;
  const subMenu = menuItem.querySelector(".sub-menu");

  clearTimeout(window.hoverTimeout);

  if (event.type === "mouseenter") {
    window.hoverTimeout = setTimeout(() => {
      menuItem.classList.add("hover");
      if (subMenu) {
        adjustSubMenuPosition(subMenu);
      }
    }, 50);
  } else if (event.type === "mouseleave" || event.type === "click") {
    menuItem.classList.remove("hover");
  }
}

function addMenuClicks() {
  const menuItems = document.querySelectorAll(
    ".desktop-menu-wrap ul.navbar-nav > li.menu-item",
  );
  menuItems.forEach((menuItem) => {
    menuItem.addEventListener("mouseenter", toggleHover);
    menuItem.addEventListener("mouseleave", toggleHover);
    menuItem.addEventListener("click", toggleHover);
  });

  const mobileMenuItems = document.querySelectorAll(
    ".mobile-menu-nav ul.navbar-nav > li.menu-item",
  );
  mobileMenuItems.forEach((menuItem) => {
    let firstlink = menuItem.querySelector("a");
    if (firstlink.getAttribute("href") == "#") {
      menuItem.addEventListener("click", window.mobileSubmenuToggle);
    }
  });

  const mobileFooterTopItems = document.querySelectorAll(
    ".site-footer ul.primary-menu>li",
  );
  mobileFooterTopItems.forEach((menuItem) => {
    let firstlink = menuItem.querySelector("a");
    if (firstlink.getAttribute("href") == "#") {
      firstlink.addEventListener("click", window.mobileFooterClicks);
    }
  });
}
